import React from 'react';

function Disclaimer(){
    return (
        <div>
              <p className="disclaimer">
                <span className="text-error">Disclaimer: </span> This application is not an initiative of GNPC GHANA and does not in the remotest way reflect their activities. It is our [<a href="https://github.com/romeo-folie/" target='blank' className="text-error">Romeo</a> and <a href="https://github.com/ankorgh/" target='blank' className="text-error">Ankor</a>] way of getting more undergraduate students to know of GNPC's generous scholarship when it is available
              </p>
        </div>
    );
}

export default Disclaimer;



// WEBPACK FOOTER //
// ./src/components/Disclaimer.js